import { render, staticRenderFns } from "./updateCourse.vue?vue&type=template&id=52ff70a9&scoped=true&"
import script from "./updateCourse.vue?vue&type=script&lang=js&"
export * from "./updateCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff70a9",
  null
  
)

export default component.exports